import { Record, Map } from "immutable";

const FormsRecord = Record({
  login: new (Record({
    disabled: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    fields: new (Record({
      email: "",
      password: "",
      username: "",
      token: "",
      grant_type: "",
      is2FA: false,
      scope: "",
      client_id: "",
      client_secret: ""
    }))()
  }))()
});

// We can subclass FormRecord to add custom getters or methods.
export default class Forms extends FormsRecord {}



// WEBPACK FOOTER //
// ./src/common/auth/forms.js